let usersService = function usersServiceFn () {
  return {
    name: 'users'
  };
};

export default usersService;



/** WEBPACK FOOTER **
 ** ./services/users/users.service.js
 **/